<template>
  <div class="p-3">
    <b-form>
      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-info-circle mr-2"></i> INFORMAÇÕES ADICIONAIS
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="6">
              <b-form-group label="Informações Adicionais de Interesse do Fisco" class="premium-form-group">
                <b-form-textarea rows="6" v-model="nfe.OB_ADICIONAIS_FISCO" maxlength="1000" class="rounded-lg" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Informações Complementares de Interesse do Contribuinte" class="premium-form-group">
                <b-form-textarea rows="6" v-model="nfe.OB_COMPLEMENT_CONTRIBUINTE_ORIG" maxlength="1000" class="rounded-lg" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group label="Texto do Tipo de Movimentação" class="premium-form-group mb-0">
                <b-form-textarea rows="6" v-model="nfe.OBS_OUTROS" maxlength="1000" class="rounded-lg" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'NfeAbaInfoAdic',
  props: { 
    nfe: { type: Object, required: true },
    podeEditar: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeAbaInfoAdic.vue